export default from './BulkMessaging';



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/DesktopMessages/components/BulkMessaging/index.js